





































import { Component,Vue } from 'vue-property-decorator';
import { getApplyTipsDialog, setApplyTipsDialog } from '@/utils/storage_session';
import { countStudentDraftApi } from '@/api/index';
@Component({
  name: 'applyTipsDialog',
})
export default class extends Vue {
  public isShow:boolean=false;
  public applyNum:number=0;
  // 获取是否有未提交的申请
  public async checkApplyData(){
    const { data }: any = await countStudentDraftApi();
    if (data.code === '1003' && data.data > 0) {
      this.applyNum = data.data;
      const key: any = getApplyTipsDialog();
      if (!key) { 
        this.open();
        return true;
      }
    }
    return false;
  }
  // 保存
  public handleSend(){ 
    setApplyTipsDialog(true);
    this.close();
    this.$emit('handleSend');
    const queryter:any = {
      stepId:[21]
    };
    this.$router.push({ name: 'applicationList', query: queryter })
  }
  public handleClose(){
    setApplyTipsDialog(true);
    this.close()
    this.$emit('handleClose');
  }
  // 显示弹窗
  public open(applyNum?: number){
    if (typeof applyNum === 'number') {
      this.applyNum = applyNum;
    }
    this.isShow=true;
  }
  // 关闭弹窗
  public close(){ 
    this.isShow=false;
  }
}
